import { ListEnum as t } from "../list-enum.mjs";
import s from "../../../icons/list-ol-icon.mjs";
import c from "../../../icons/list-ul-icon.mjs";
const a = ({ listType: e, editor: r }) => {
  if (r)
    switch (e) {
      case t.BulletList:
        r.chain().focus().toggleBulletList().run();
        break;
      case t.OrderedList:
        r.chain().focus().toggleOrderedList().run();
        break;
    }
}, l = ({ listType: e }) => {
  switch (e) {
    case t.BulletList:
      return c;
    case t.OrderedList:
      return s;
  }
}, o = (e) => {
  switch (e) {
    case 0:
      return "disc";
    case 1:
      return "circle";
    default:
      return "square";
  }
}, L = (e) => {
  switch (e) {
    case 0:
      return "decimal";
    case 1:
      return "lower-latin";
    case 2:
      return "lower-roman";
    case 3:
      return "upper-latin";
    default:
      return "upper-roman";
  }
};
export {
  o as getBulletListStyleType,
  l as getListIcon,
  L as getOrderedListStyleType,
  a as setList
};
